@if (message) {
  <div class="snackbar-container" [@fade]="{value: !!message}">
    <div class="msg-box">{{message}}</div>
  </div>
}
